export default __webpack_public_path__ + "static/media/tokenomic3.1b30af6b.png";